import '../../../types/AccessDevice.js';
import '../../../types/Analytics.js';
import '../../../types/CASACommunity.js';
import '../../../types/Community.js';
import '../../../types/DxSettings.js';
import '../../../types/MagicButton.js';
import '../../../types/Pannellum.js';
import '../../../types/Prospect.js';
import '../../../types/ProspectIntelligence.js';
import { SpaceType, NodeLinkType } from '../../../types/Space.js';
import '../../../types/Tour.js';
import 'date-fns/format';
import 'date-fns/secondsToMinutes';
import 'date-fns/isValid';
import 'date-fns/addMinutes';
import 'date-fns';
import 'date-fns-tz';
import 'react';
import { useError } from '../../../utils/ErrorProvider.js';
import { useLoader } from '../../../utils/LoaderProvider.js';
import { useRefetch } from '../../../utils/RefetchProvider.js';
import '../../../utils/NotificationProvider.js';
import 'tslib';
import '../../../utils/ContactProvider.js';
import '../../../utils/PolicyProvider.js';
import { useAnalytics } from '../../../utils/AnalyticsProvider.js';
import '@analytics/storage-utils';
import '../../../utils/analyticsPlugin.js';
import '../../../utils/communityGoogleAnalyticsPlugin.js';
import 'qs';
import '../../../utils/cookieUtils.js';
import '../../../utils/termsConditionsAgreementsUtils.js';
import { usePannellumViewer } from './PannellumProvider.js';
import { getPannellumSceneConfig, getNodeById } from './pannellumUtils.js';

const useLoadScene = () => {
    const { getContainer, getConfig, addScene, loadScene: pannellumLoadScene, isEditing, setYaw, setHfov, setPitch, setYawBounds, getScene, setViewerContext, getSpaceToken, } = usePannellumViewer();
    const { setError } = useError();
    const { setLoader } = useLoader();
    const { setRefetch } = useRefetch();
    const analytics = useAnalytics();
    const helpers = {
        setError,
        setLoader,
        setRefetch,
        setViewerContext,
    };
    const loadScene = (payload) => {
        var _a;
        const { node, details, targetSettings, refresh, token, staged } = payload;
        const sceneId = node === null || node === void 0 ? void 0 : node._id;
        const scenes = getConfig().scenes;
        if (!Object.keys(scenes).includes(sceneId) || refresh) {
            addScene(sceneId, getPannellumSceneConfig({
                node,
                isMultires: details.isMultiRes,
                isHorizonLevel: details.isHorizonLevel,
                relatedContext: {
                    id: details._id,
                    isEditing,
                },
                brandingColor: (_a = details.community) === null || _a === void 0 ? void 0 : _a.secondaryColor,
                helpers: Object.assign(Object.assign({}, helpers), { getContainer, loadNodeLink: (nodeLink) => loadNodeLink(nodeLink, details, token), clickEventAnalytics: (clickedEleName, customTags) => analytics === null || analytics === void 0 ? void 0 : analytics.track(clickedEleName, customTags) }),
                staged,
            }));
        }
        if (details.type !== SpaceType.Amenity) {
            setViewerContext({ unitSceneId: sceneId });
        }
        setTimeout(() => {
            analytics === null || analytics === void 0 ? void 0 : analytics.track("Room View", {
                roomId: node === null || node === void 0 ? void 0 : node._id,
                roomName: node === null || node === void 0 ? void 0 : node.label,
                spaceType: details.type,
                spaceId: details._id,
            });
        }, 0);
        pannellumLoadScene(sceneId, targetSettings === null || targetSettings === void 0 ? void 0 : targetSettings.pitch, targetSettings === null || targetSettings === void 0 ? void 0 : targetSettings.yaw, targetSettings === null || targetSettings === void 0 ? void 0 : targetSettings.hfov);
    };
    const loadSceneWithStageCheck = (id, details, token, refresh) => {
        const node = getNodeById(details.nodes, id);
        loadScene({ node, details, refresh, token, staged: true });
    };
    const loadLinkedSpaces = (nodeLink, details) => {
        const { spaceId } = nodeLink;
        const newDetailsToLoad = { _id: spaceId };
        setViewerContext({
            linkedSpaceDetails: newDetailsToLoad,
        });
        getSpaceToken({ spaceId: spaceId });
    };
    const loadNodeLink = (nodeLink, details, token, updatedMultiresConfig) => {
        var _a, _b;
        const currentNodeId = getScene();
        if (nodeLink.type === NodeLinkType.Space) {
            loadLinkedSpaces(nodeLink);
        }
        else {
            const targetNode = getNodeById(details.nodes, nodeLink.node);
            const sourceNodeLinkInTargetScene = targetNode === null || targetNode === void 0 ? void 0 : targetNode.nodeLinks.find(({ node }) => node === currentNodeId);
            if (targetNode) {
                const targetSettings = {
                    yaw: (((_a = sourceNodeLinkInTargetScene === null || sourceNodeLinkInTargetScene === void 0 ? void 0 : sourceNodeLinkInTargetScene.rotation) === null || _a === void 0 ? void 0 : _a.yaw) || 0) + 180,
                };
                setYawBounds([-360, 360]);
                setPitch(0, 1000, loadScene, {
                    node: targetNode,
                    details,
                    targetSettings,
                    token,
                    staged: true,
                    updatedMultiresConfig,
                });
                setYaw(((_b = nodeLink.rotation) === null || _b === void 0 ? void 0 : _b.yaw) || 0, 1000);
                setHfov((document.documentElement.clientWidth < document.documentElement.clientHeight && 80) || 115, 1000);
            }
        }
    };
    return { loadScene, loadSceneWithStageCheck, loadNodeLink };
};

export { useLoadScene as default, useLoadScene };
